import { IAugmentedJQuery } from 'angular';

export function applyRoleAndValidateAriaLabel(element: IAugmentedJQuery, roleName: string) {
	element.attr('role', roleName);

	if(!element.attr('aria-labelledby') && !element.attr('aria-label')) {
		console.warn(' vb-ui-date-picker missing aria-label');
	}
}
